/**
 * Where a dragged block lands (spec §8.6 item 4, M16): decided by the pointer's vertical position over
 * the target row — top quarter before, bottom quarter after, the middle half of a group row into the
 * group; on other rows the nearer half decides.
 */
import type { LoroDoc, TreeID } from "loro-crdt";
import { blocksTree } from "./model";

export type DropPlacement = "before" | "after" | "into";

export function dropPlacement(pointerY: number, rect: { top: number; height: number }, isGroup: boolean): DropPlacement {
  const f = rect.height > 0 ? (pointerY - rect.top) / rect.height : 0.5;
  if (f < 0.25) return "before";
  if (f > 0.75) return "after";
  if (isGroup) return "into";
  return f < 0.5 ? "before" : "after";
}

/** Whether `target` is `block` itself or lies inside it (a block cannot be dropped into itself). */
export function isSelfOrDescendant(doc: LoroDoc, block: TreeID, target: TreeID): boolean {
  const tree = blocksTree(doc);
  for (let id: TreeID | undefined = target; id; id = tree.getNodeByID(id)?.parent()?.id) if (id === block) return true;
  return false;
}
